import SnackbarMobile from './SnackbarMobile';
import SnackbarDesktop from './SnackbarDesktop';
import { SnackbarProps as VKSnackbarProps } from '@vkontakte/vkui/dist/components/Snackbar/Snackbar';
import { getPlatformComponent } from '../utils/getPlatformComponent';

export type SnackbarProps = VKSnackbarProps;

export default getPlatformComponent<SnackbarProps>({ mobile: SnackbarMobile, desktop: SnackbarDesktop });
